import { render, staticRenderFns } from "./AccessControlSystem.vue?vue&type=template&id=0ec56b9e&scoped=true"
import script from "./AccessControlSystem.vue?vue&type=script&lang=js"
export * from "./AccessControlSystem.vue?vue&type=script&lang=js"
import style0 from "./AccessControlSystem.vue?vue&type=style&index=0&id=0ec56b9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec56b9e",
  null
  
)

export default component.exports